export const WelcomeDelta = 'welcome-delta';
export const LangSelector = 'langSelector';
export const Advisory = 'advisory';
